// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import Tabs from 'presentations/views/components/atoms/Tabs';
import styled from '@emotion/styled';
import { gray04, white } from 'presentations/views/styles/color';
import { spacing } from 'presentations/views/styles';
import { useDashboardServiceNavigation } from './hooks';
import { ViewerItem } from 'presentations/api/schema/user';
import { Role } from 'domains/models/team_user/role';

export enum SectionAdminView {
  home = 0,
  payment = 1,
  businessProfile = 2,
  taxRate = 3,
}

export enum SectionMemberView {
  home = 0,
  taxRate = 1,
}

interface Props {
  activeIndex: number | null;
  viewer: ViewerItem;
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);

  const { state, actions } = useDashboardServiceNavigation({
    viewer: props.viewer,
  });

  let tabs = [];
  if (props.viewer.role > Role.Admin) {
    tabs = [{ label: t('Home') }, { label: t('TaxRate') }];
  } else {
    tabs = [
      { label: t('Home') },
      { label: t('Payment') },
      { label: t('BusinessProfile') },
      { label: t('TaxRate') },
    ];
  }

  return (
    <>
      {props.activeIndex !== null && (
        <NavigationContainer>
          <Tabs
            indicatorColor="primary"
            value={props.activeIndex}
            onChange={actions.onChangeTab}
            tabs={tabs}
          />
        </NavigationContainer>
      )}
    </>
  );
}

const NavigationContainer = styled.div`
  padding: 0 ${spacing(24)};
  background-color: ${white};
  position: sticky;
  top: 0px;
  z-index: 1;
  border-bottom: 1px solid ${gray04};
`;
